(function(){
'use strict';

angular.module('classy').component('egPayPlaid', {
  require: {
    ngModelCtrl: 'ngModel'
  },
  templateUrl: 'global/embedded-giving/pay/components/plaid/eg.pay.components.plaid', // same folder as this
  bindings: {
    model: '<',
    onSuccess: '&',
    onCancel: '&',
    currency: '<',
    style: '<'
  },
  controller: ["$log", "cpAPI", "bugsnagClient", "cpConstants", "EmbeddedGivingPaths", "scThemesService", "scDigitalWalletsService", "$state", "$rootScope", function controller($log, cpAPI, bugsnagClient, cpConstants, EmbeddedGivingPaths, scThemesService, scDigitalWalletsService, $state, $rootScope) {
    var _this2 = this;

    this.constants = cpConstants;
    this.config = {};
    this.primaryColor = scThemesService.active.current.styles.primaryColor;
    this.isDonationAchTerms = !!$state.current.name.includes('frs.donation.checkout');
    this.EmbeddedGivingPaths = EmbeddedGivingPaths;
    this.clientUserId = (SC.member.id || SC.heapId).toString(); // Converting id to string as required

    this.$onChanges = function () {
      if (this.currency && this.model.status !== cpConstants.STATUS.INACTIVE) this.setupPlaid();
    };

    this.setupPlaid = function () {
      var _this = this;

      cpAPI.getPlaidToken(this.clientUserId).then(function (_ref) {
        var linkToken = _ref.linkToken;

        _this.model.status = cpConstants.STATUS.READY;
        _this.config.linkToken = linkToken;
      }).catch(bugsnagClient.notify);
    };

    this.openPlaidDialog = function () {
      this.onCancel();
      var linkToken = this.config.linkToken;

      Plaid.create({
        product: ['auth'],
        clientName: 'Classy Pay',
        selectAccount: true,
        token: linkToken,
        onSuccess: this.onPlaidSuccess.bind(this),
        onExit: this.onPlaidCancel.bind(this)
      }).open();
    };

    this.onPlaidReady = function () {
      $log.log('Plaid Ready');
    };

    this.onPlaidSuccess = function (publicToken, metadata) {
      this.model.status = cpConstants.STATUS.SUCCESS;
      this.model.accountId = metadata.account_id;
      this.model.accountName = metadata.account.name;
      this.model.publicToken = publicToken;
      this.model.achTermsAccepted = false;
      this.ngModelCtrl.$setValidity('required', true);
      this.ngModelCtrl.$setDirty();
      var lastFour = metadata.account.mask;
      var accountType = metadata.account.subtype;
      this.onSuccess({ lastFour: lastFour, accountType: accountType });
    };

    scDigitalWalletsService.addOnDigitalWalletsSubmitListener(function () {
      if (_this2.model.status !== cpConstants.STATUS.SUCCESS) {
        return;
      }
      _this2.onPlaidCancel();
    });

    this.onPlaidCancel = function () {
      this.ngModelCtrl.$setViewValue(cpConstants.STATUS.READY);
      this.ngModelCtrl.$setPristine();
      this.ngModelCtrl.$setUntouched();
      this.onCancel();
    };

    $rootScope.$on('openPaymentModal', function (_event, paymentMethod) {
      if (paymentMethod === _this2.constants.PAYMENT_METHODS.ACH) {
        _this2.openPlaidDialog();
      }
    });
  }]
});
})();